const initialState = {
  authenticated: localStorage.getItem('access_token') !== null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'AUTHENTICATED':
      const { authenticated } = action;
      return {
        ...state,
        authenticated,
      };
    default:
      return state;
  }
};

export const setAuthentication = (
  authenticated,
) => ({
  type: 'AUTHENTICATED',
  authenticated,
});
